import { atom } from "recoil";

export const insetState = atom<number | null>({
  key: "inset",
  default: null,
});
